import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    width: '100%',
  },
  breadcrumb: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  backArrow: {
    color: theme.palette.text.secondary,
    cursor: 'pointer',
  },
  breadcrumbText: {
    color: theme.palette.text.secondary,
    cursor: 'pointer',
  },
  breadcrumbSeparator: {
    color: theme.palette.text.secondary,
  },
  breadcrumbCurrent: {
    color: theme.palette.text.primary,
  },
  pageTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  infoRow: {
    display: 'flex',
    gap: theme.spacing(6),
    marginBottom: theme.spacing(3),
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  infoLabel: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
  infoValue: {
    fontWeight: 500,
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  sectionHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  sectionIcon: {
    color: theme.palette.primary.main,
    fontSize: 28,
  },
  sectionTitle: {
    fontWeight: 'bold',
  },
  tablePaper: {
    overflowX: 'auto',
  },
  tableToolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1),
  },
  headerCell: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  bodyCell: {
    whiteSpace: 'nowrap',
  },
  chipFinished: {
    borderColor: '#4caf50',
    color: '#4caf50',
    fontWeight: 'bold',
    fontSize: '0.7rem',
  },
  chipLeft: {
    borderColor: '#ff9800',
    color: '#ff9800',
    fontWeight: 'bold',
    fontSize: '0.7rem',
  },
  chipNotStarted: {
    borderColor: theme.palette.text.secondary,
    color: theme.palette.text.secondary,
    fontWeight: 'bold',
    fontSize: '0.7rem',
  },
  retryButton: {
    borderColor: '#4caf50',
    color: '#4caf50',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    '&:hover': {
      borderColor: '#388e3c',
      backgroundColor: 'rgba(76, 175, 80, 0.08)',
    },
  },
}));
